import axios, { AxiosResponse } from 'axios';
import {useCallback} from 'react';

const CEP_API = 'https://viacep.com.br/ws';

interface CEPResponse {
  bairro: string;
  cep: string;
  complemento: string;
  ddd: string;
  estado: string;
  gia: string;
  ibge: string;
  localidade: string;
  logradouro: string;
  regiao: string;
  siafi: string;
  uf: string;
  unidade: string;
  erro?: boolean
}

const useCep = () => {
  const buscaCep = useCallback(
    (cep: string): Promise<AxiosResponse<CEPResponse>> => axios.get(`${CEP_API}/${cep}/json/`),
    [],
  );
  return {
    buscaCep,
  };
};

export default useCep;
